<template>
    <app-layout title="Settings">
        <form @submit.prevent="submit">
            <page-header>
                <template #title>Settings - General</template>

                <template #actions>
                    <jet-button type="submit" class="h-7 leading-none" :disabled="form.processing" >
                        Save
                    </jet-button>
                </template>
            </page-header>

            <settings-navigation />

            <div class="px-8 grid-cols-4">
                <div class="w-80 form-group">
                    <jet-label value="Auto-print Enabled" />
                    <div>
                        <toggle class="block" id="autoprint_enabled" v-model="form.autoprint_enabled" />
                        <div class="text-xs text-gray-500">Refresh pages you wish to print from with the new method after updating this setting.</div>
                    </div>
                </div>

                <div class="w-80 form-group">
                    <jet-label value="Wholesale Delivery Order Minimum" />
                    <div class="flex">
                        <span class="pt-1 px-3 border border-r-0 rounded-r-none rounded-l">$</span>
                        <jet-input type="number" v-model="form.wholesale_delivery_order_minimum" class="w-full rounded-l-none" />
                    </div>
                </div>

                <div class="w-80 form-group">
                    <jet-label value="Wholesale Delivery Fee Below Minimum" />
                    <div class="flex">
                        <span class="pt-1 px-3 border border-r-0 rounded-r-none rounded-l">$</span>
                        <jet-input type="number" v-model="form.wholesale_delivery_fee_below_minimum" class="w-full rounded-l-none" />
                    </div>
                    <div class="text-xs text-gray-500">Leave blank to refuse orders below the order minimum.</div>
                </div>
                
                <div class="w-80 form-group">
                    <jet-label value="Number of delivery days" />
                    <multiselect
                        v-model="form.number_of_delivery_days"
                        :options="numberDays"
                        :classes="{ singleLabel: 'w-full px-2' }"
                        class="multi-lg h-7 text-base"
                        placeholder="Select number"
                    />
                    <jet-input-error :message="$page.props.errors.type" class="mt-1" />
                </div>

                <div class="w-80 form-group">
                    <jet-label value="Evening delivery cut off at" />
                    <jet-input type="time" v-model="form.delivery_past_evening_cut_off" class="w-full" min="1" />
                </div>

                <div class="w-80 form-group">
                    <jet-label value="Pickup Early Afternoon (12-3) Cutoff" />
                    <jet-input type="time" v-model="form.pickup_afternoon_cutoff" class="w-full" min="1" />
                </div>

                <!-- <div class="w-80 form-group">
                    <jet-label value="Pickup Late Afternoon (3-5) Cutoff" />
                    <jet-input type="time" v-model="form.pickup_late_afternoon_cutoff" class="w-full" min="1" />
                </div> -->

                <div class="w-80 form-group">
                    <jet-label value="Pickup Late Afternoon / Evening (3-7) Cutoff" />
                    <jet-input type="time" v-model="form.pickup_evening_cutoff" class="w-full" min="1" />
                </div>
            </div>
        </form>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetLabel from '@/Jetstream/Label';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError.vue';
import JetButton from '@/Jetstream/Button';
import SettingsNavigation from '@/Pages/Settings/Partials/SettingsNavigation';
import Multiselect from '@vueform/multiselect';
import Toggle from '@vueform/toggle';

import '@vueform/multiselect/themes/default.css';
import '@vueform/toggle/themes/default.css';

export default {
    setup(props) {
        const form = useForm({
            autoprint_enabled: props.settings.find(item => item.label === 'autoprint_enabled').value,
            wholesale_delivery_order_minimum: props.settings.find(item => item.label === 'wholesale_delivery_order_minimum').value,
            wholesale_delivery_fee_below_minimum: props.settings.find(item => item.label === 'wholesale_delivery_fee_below_minimum').value,
            number_of_delivery_days: props.settings.find(item => item.label === 'number_of_delivery_days').value,
            delivery_past_evening_cut_off: props.settings.find(item => item.label === 'delivery_past_evening_cut_off').value,
            pickup_afternoon_cutoff: props.settings.find(item => item.label === 'pickup_afternoon_cutoff').value,
            pickup_evening_cutoff: props.settings.find(item => item.label === 'pickup_evening_cutoff').value,
        });

        return { form }
    },

    components: {
        AppLayout,
        PageHeader,
        JetLabel,
        JetInput,
        JetInputError,
        JetButton,
        SettingsNavigation,
        Multiselect,
        Toggle,
    },

    props: ['settings', 'numberDays'],

    data() {
        return {
        }
    },

    methods: {
        submit() {
            this.form.submit('post', route('settings.general.store'));
        },
    },
}
</script>

<style scoped>
</style>
